import axios from '@/lib/axios';
import { PromoCareOrderParams } from '../types';

const confirmPromoCare = (data: PromoCareOrderParams) => {
  return axios.post('/facility/orders/promo_care/confirm', data);
}

export default confirmPromoCare;